import { render } from "./AppUpdateAvailable.vue?vue&type=template&id=76f8f157&scoped=true&lang=pug"
import script from "./AppUpdateAvailable.vue?vue&type=script&lang=js"
export * from "./AppUpdateAvailable.vue?vue&type=script&lang=js"

import "./AppUpdateAvailable.vue?vue&type=style&index=0&id=76f8f157&lang=scss&scoped=true"

import exportComponent from "/Users/edsonfer/Documents/dev-projects/node-projects/portal-gignet-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76f8f157"]])

export default __exports__